<template>
  <div v-if="data != '' && data != null" class="text">
    <div @click.shift="handleClick" >
      <span class="result-title" v-if="title">{{title}}{{noColon ? "" : ":"}}</span>
      <span
          v-bind:class="{ largerfont: largerFont }"
          v-html="this.highlightedText"
          v-if="!editing"
      ></span>
    </div>
    <div v-if="editing" >
      <textarea  ref="textarea" v-bind:class="{ largerfont: largerFont }" class="editing-text-area" v-model="editingText"></textarea>
      <button @click="handleSaveEdit" class="button" style="margin-top: 5px;">Save</button>
      <button @click="handleCancelEdit" class="button" style="margin-top: 5px;">Cancel</button>
    </div>
    <div v-if="allowsTranslation" class="definition-translation">
      <ResultTranslation :columnName="columnName" :tibetanText="this.text"/>
    </div>
  </div>
</template>

<script>

import {mapMutations, mapState} from 'vuex'
import jsEwts from '../jsewts'
import Vue from "vue";
import Utils from '../utils'
import ResultTranslation from './ResultTranslation.vue';

export default {
  name: 'ResultDisplay',
  props: {
    data: [String, Number],
    title: String,
    columnName: String,
    entryId: Number,
    largerFont: {tyoe: Boolean, value: false},
    noColon: {tyoe: Boolean, value: false},
    processWylie: {tyoe: Boolean, value: false},
    processNumbers: {tyoe: Boolean, value: false},  // should numbered lists be detected and moved to new lines?
    allowsTranslation: {type: Boolean, value: false},
  },
  data() {
    return {
      editing: false,
      editingText: this.data,
      text: this.data
    }
  },
  components: {
    ResultTranslation
  },
  computed: {
    ...mapState('app', [
      'searchText',
      'searchType',
      'allowEdits',
      'editInProcess',
      'editToken'
    ]),
    highlightedText() {

      // process the newlines
      let replaceNewlines = this.processNewLines(this.text);

      // replace wylie within {...} with unicode
      // TODO: why can't I use a class here?
      if (this.processWylie) {
        replaceNewlines = replaceNewlines.replace(/{([\u0020-\u007C\u007E-\u007F]+)}/gm, function (match, p1) {
          return '<span class="tibetan-result-text">' + jsEwts.toUnicode(p1) + '</span>'
        });
      }

      // detect numbered lists (like 1), 2), 3), etc...) and shift them to new lines
      if (this.processNumbers) {
        replaceNewlines = replaceNewlines.replace(/[0-9]+\)/gm, function (match) {
          return '<br/>' + match
        });
        replaceNewlines = replaceNewlines.replace(/^<br\/>/gm, "");
      }

      // don't highlight on certain search types
      if (this.searchType === 'definiendumStarts' || this.searchType === 'definiendumLike' || this.searchType === 'definiendumRegex') {
        return replaceNewlines;
      }

      // highlight the search term
      else {
        return Utils.highlight(replaceNewlines, this.searchText, "highlight", this.searchType);
      }
    }
  },
  methods: {
    ...mapMutations([
      'setEditInProcess',
    ]),
    handleClick() {
      if (this.allowEdits) {
        if (this.editInProcess) {
          alert("Finish open edit first")
          return
        }
        this.editing = true;
        this.setEditInProcess(true);
        Vue.nextTick(() => {
          this.resizeTextArea();
        });
      }
    },
    async handleSaveEdit() {
      this.text = this.editingText;
      await this.saveEdit();
      this.setEditInProcess(false);
    },
    handleCancelEdit() {
      this.editing = false;
      this.setEditInProcess(false);
    },
    async saveEdit() {
      // eslint-disable-next-line no-console
      this.$log.debug(`Editing id=${this.entryId}, column = ${this.columnName} new value = "${this.text}"`)
      const newValue = this.text
      await this.$server.dictionaryService.patch(this.entryId, {
        value: newValue,
        columnName: this.columnName,
        comment: "",
        user: "",
        entryId: this.entryId,
        token: this.editToken
      });
      this.editing = false;
    },
    resizeTextArea() {
      const {textarea} = this.$refs;
      textarea.style.height = textarea.scrollHeight + 10 + 'px';
    },
    processNewLines(input) {
      let processedInput = input
      // if there is a newline in the text block, add an initial newline to shift
      // the whole thing down below the heading
      if (this.title && /\n|\\n/.exec(processedInput)) {
        processedInput = "\n" + processedInput
      }
      // eslint-disable-next-line no-control-regex
      return processedInput.replace(/\n|(\\n)|\u000b/gm, "<br/>").replace(/།་/g, "། ");
    }
  }
}
</script>

<style>
.tibetan-result-text {
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .result-title {
    margin-right:5px;
    color: #7b7b7b;
  }

  .largerfont {
    font-size: 160%;
    line-height: 80%;
  }

  .editing-text-area {
    width: 100%;
  }

  .button {

    border: 0;
    outline: 0;
    cursor: pointer;
    color: rgb(60, 66, 87);
    background-color: transparent;
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 8px;
    display: inline-block;
    min-height: 28px;
    transition: background-color .24s,box-shadow .24s;
  }

  button:hover {
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 3px 9px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
  }


</style>
